import React, { useEffect, useState } from 'react';
import '../../styles/Slider.css';
import management from '../Assets/management.svg';
import appearance from '../Assets/appearance.svg';
import legal from '../Assets/legal.svg';
import dispute from '../Assets/dispute.svg';

const Services: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      imgSrc: dispute,
      altText: "Dispute Resolution",
      title: "Dispute Resolution",
      description: "Litigation, Mediation, arbitration, and other alternative dispute resolution (ADR) processes",
    },
    {
      imgSrc: legal,
      altText: "Legal Advice",
      title: "Legal Advice",
      description: "Consultations with experienced attorneys",
    },
    {
      imgSrc: appearance,
      altText: "Court Appearances",
      title: "Court Appearances",
      description: "Virtual hearings and trials",
    },
    {
      imgSrc: management,
      altText: "Document Filing and Management",
      title: "Document Filing and Management",
      description: "",
    }
  ];
  
  const totalSlides = slides.length;

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    }, 3000);

    return () => clearInterval(slideInterval);
  }, [totalSlides]);

  return (
    <div className="pt-20 flex flex-col md:mx-10 gap-5">
        <h3 className="text-[29px] font-bold text-center">Our Services</h3>
        <div className="slider-container flex justify-center items-center mx-auto mb-20">
            <div
            className="slider mx-10 gap-3 md:gap-10"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
            {slides.map((slide, index) => (
                <div className="slide px-3 md:px-20" key={index}>
                    <img src={slide.imgSrc} alt={slide.altText} />
                    <div className="flex flex-col gap-3 text-left text-[18px] md:text-[26px] justify-center md:mr-40">
                        <h4 className="font-bold">{slide.title}</h4>
                        <p className='text-wrap'>{slide.description}</p>
                    </div>
                </div>
            ))}
            </div>
            
        </div>
        {/* <div className="dots-container flex justify-center mt-5">
            {slides.map((_, index) => (
                <span
                key={index}
                className={`dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
                ></span>
            ))}
        </div> */}
    </div>
  );
};

export default Services;
